import { AppTFunction } from '@retail/app/i18n';
import * as yup from 'yup';

export const priceItemSchema = (t: AppTFunction) =>
  yup.object({
    fromDate: yup.date().default(new Date()).required(t('calculus.error.requiredField')),
    salesPrice: yup
      .number()
      .nullable()
      .notRequired()
      .typeError(t('calculus.error.mustBeNumberOver0'))
      .transform((_, value: string | null) => {
        if (value) {
          return Number((value + '').replace(',', '.'));
        }
        return undefined;
      })
      .positive(t('calculus.error.mustBeNumberOver0')),
    primaryUnit: yup.string().required(),
  });

export const bulkEditPricesSchema = (t: AppTFunction) =>
  yup.object({
    items: yup.lazy((value) => {
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const shape = Object.keys(value).reduce((acc, key) => {
          acc[key] = priceItemSchema(t);
          return acc;
        }, {} as Record<string, any>);

        return yup.object().shape(shape);
      }

      return yup.object();
    }),
  });

export type PriceItemSchema = yup.InferType<ReturnType<typeof priceItemSchema>>;

export type BulkEditPricesSchema<PriceItemSchema> = {
  items: Record<string, PriceItemSchema>;
};
